import { FC, ReactNode } from "react";

import Box from "@mui/material/Box";

interface TabPanelProps {
	children?: ReactNode;
	index: number;
	currentTab: number;
	/** When true, the tab content fills remaining height (for scroll containment) */
	fill?: boolean;
	sx?: object;
	panelId?: string;
	labelledById?: string;
}

export const TabPanel: FC<TabPanelProps> = (props: TabPanelProps) => {
	const {
		children,
		currentTab: value,
		index,
		fill,
		sx: sxProp,
		panelId: panelIdProp,
		labelledById: labelledByIdProp,
		...other
	} = props;
	const isHidden = value !== index;
	const panelId = panelIdProp ?? `simple-tabpanel-${index}`;
	const labelledById = labelledByIdProp ?? `simple-tab-${index}`;

	return (
		<Box
			role="tabpanel"
			hidden={isHidden}
			id={panelId}
			aria-labelledby={labelledById}
			sx={{
				width: "100%",
				minWidth: 0,
				...(isHidden && { display: "none" }),
				...(fill &&
					!isHidden && {
						flex: "1 1 0%",
						minHeight: 0,
						display: "flex",
						flexDirection: "column",
						overflow: "hidden",
						p: 0,
						m: 0,
					}),
				...(sxProp && (typeof sxProp === "object" ? sxProp : {})),
			}}
			{...other}
		>
			{value === index && (
				<Box
					sx={
						fill
							? {
									flex: "1 1 0%",
									width: "100%",
									minWidth: 0,
									minHeight: 0,
									display: "flex",
									flexDirection: "column",
									overflow: "hidden",
									p: 0,
									m: 0,
								}
							: { width: "100%", minWidth: 0, p: 0, m: 0 }
					}
				>
					{children}
				</Box>
			)}
		</Box>
	);
};
